import { createFileRoute } from '@tanstack/react-router'
import PageEntrance from '~components/motion/page-entrance'
import Attachment from '~containers/app/ask-a-vet/5_attachment'
import { SamsungSmartThingsMetadata } from '~types/samsung.smart-things'
import getMetadata from '~utils/app/get-metadata'

export const Route = createFileRoute('/samsung/smart-things/(app)/ask-a-vet/attachment')({
  component: RouteComponent,
})

const defaultMetadata = {
  stEnv: import.meta.env.VITE_ENV ?? 'acceptance',
} satisfies SamsungSmartThingsMetadata

function RouteComponent() {
  const metadata = Object.assign(defaultMetadata, JSON.parse(getMetadata() || '{}'))
  const st_metadata = { st_counsel_id: metadata.counselId, st_env: metadata.stEnv }

  return (
    <PageEntrance>
      <Attachment metadata={st_metadata} />
    </PageEntrance>
  )
}
